export default __webpack_public_path__ + "4f59d866bb25748911a403fca9d8f640.png";